/* eslint-disable react/no-multi-comp */
import React, { Component, PureComponent } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import get from 'lodash/get';
import each from 'lodash/each';
import map from 'lodash/map';
// import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import numDesc from 'helpers/numDesc';
import absoluteUrl from 'helpers/absoluteUrl';
import cacheTerms from 'helpers/cacheTerms';
import Dict from 'api/data-dict';
import preload from 'api/data-preload';
import DataProvider from 'api/data-provider';
import seoPreload, { seoDecorator } from 'api/seo';
import GeoLandings from 'subsys/geo-landings';
import Container from 'components/container';
import Breadcrumbs from 'components/breadcrumbs';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
import { SeoText } from 'components/layouts';
import { OpenGraphImage } from 'components/image';
import Link from 'components/link';
import YoutubeIframe from 'components/youtube-iframe';
import { orderBigCitiesId } from 'containers/form/input-locality';

import linksBild from 'src-sites/bild/links';
import linksBildControl from 'src-sites/bildcontrol/links';
import { reliabilityIndex } from 'src-sites/bild/section-project/reliability-index';

import translates from './about-i18n';

import 'styles/bild/section-about/_page-about-us.scss';

const bemClasses = new Bem('pageAboutUs');

@preload({
  bigCities: [DataProvider.preload, {
    url: 'domik/location/administratives',
    queryJson: true,
    query: {
      ids: orderBigCitiesId,
      columnObjectCount: { project: "bild", type: "newbuilds", class: "flats" }
    },
    cache: cacheTerms.longInfoProvider
  }],
  pointsLevel: [Dict.preload, { url: 'reliability/points-level' }],
  livingComplexCondition: [Dict.preload, { url: 'reliability/living-complex' }],
  developerCondition: [Dict.preload, { url: 'reliability/developer' }],
  ...seoPreload({ entity: 'pageAbout' }, []),
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@I18nHoc(translates())
export default class PageAbout extends Component {
  static propTypes = {
    pointsLevel: PropTypes.shape({}),
    livingComplexCondition: PropTypes.shape({}),
    developerCondition: PropTypes.shape({}),
    location: PropTypes.shape({}),
    mainMenuBase: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
    bigCities: PropTypes.shape({})
  };

  renderBigCity(data) {
    return (
      <>
        {map(data.data, (city, key) => {
          if (!city.landing_header || !city.objects_landing) return null;

          return (
            <li key={key} {...bemClasses('item', 'link')}>
              <Link
                {...bemClasses('link', 'toBigCity')}
                href={city.objects_landing}
                title={city.landing_header}
              >
                <span {...bemClasses('linkContainer')}>
                  <span {...bemClasses('text', 'link')} children={city.landing_header} />
                </span>
              </Link>
            </li>
          )
        })}
      </>
    )
  }

  render() {
    const { i18n } = this;
    const {
      pointsLevel= {}, livingComplexCondition = {},
      developerCondition = {}, location, mainMenuBase, seoData, bigCities
    } = this.props;
    const dataLC = livingComplexCondition.data || [];
    const dataDeveloper = developerCondition.data || [];
    const countCondition = dataLC.length + dataDeveloper.length;
    let maxRating = 15;
    each(dataLC, val => maxRating += val.rating);
    each(dataDeveloper, val => maxRating += val.rating);
    const lowLevel = Math.round(get(pointsLevel, 'data[1].min', 0) * (maxRating / 100));
    const highLevel = Math.round(get(pointsLevel, 'data[2].min', 0) * (maxRating / 100));
    const exampleHighLevel = highLevel + 9;
    const exampleLowLevel = lowLevel - 19;

    const seoLocation = get(location, 'pathname');
    const bildUa = (
      <Link
        {...bemClasses('link')}
        builder={linksBild.sectionBild}
        builderProps={{ title: 'bild.ua' }}
        inlineBlock
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text')} children="Bild.ua" />
        </span>
      </Link>
    );
    const header = i18n('aboutBild');
    const description = i18n('description');
    const dataBreadcrumbs = [
      {
        name: i18n('main'),
        builder: linksBild.sectionBild,
        builderProps: { title: i18n('main') }
      }, {
        name: header,
        builder: linksBild.sectionAbout
      }
    ];
    const iconCloud = <span {...bemClasses('img', 'icon')} />;
    const topic = seoData && seoData.header ? seoData.header : i18n('h1');
    const seoText = get(seoData, 'bottomText', null);
    const iframeSrcId = 'pnLpiJPnRCE';

    return (
      <div {...bemClasses()}>
        <LazyHydrate whenIdle>
          <OpenGraphImage />
        </LazyHydrate>
        <LazyHydrate whenIdle>
          <Container {...bemClasses('block')} body>
            <Row {...bemClasses('row', 'welcome')} alignIcenter>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h1')}><h1 children={topic} /></div>
                <div {...bemClasses('description')}>
                  <p {...bemClasses('text', 'black')} children={description} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <span {...bemClasses('img', 'laptopHouses')} />
                </div>
              </Col>
            </Row>
          </Container>
          <Container {...bemClasses('block', 'white')}>
            <Row {...bemClasses('row', 'wait')} alignIcenter>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <span {...bemClasses('img', 'laptopCrane')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}><h2 children={i18n('h2_1')} /></div>
                <div {...bemClasses('description')}>
                  <p {...bemClasses('text')} children={i18n('description1_1')} />
                  <p {...bemClasses('text')} children={i18n('description1_2')} />
                  <ul {...bemClasses('list')}>
                    <li {...bemClasses('listItem')}>
                      <Row>
                        <Col allAuto allPr={0}>{iconCloud}</Col>
                        <Col allPr={0}><span {...bemClasses('text')} children={i18n('listQuestion1')} /></Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row>
                        <Col allAuto allPr={0}>{iconCloud}</Col>
                        <Col allPr={0}><span {...bemClasses('text')} children={i18n('listQuestion2')} /></Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row>
                        <Col allAuto allPr={0}>{iconCloud}</Col>
                        <Col allPr={0}><span {...bemClasses('text')} children={i18n('listQuestion3')} /></Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row>
                        <Col allAuto allPr={0}>{iconCloud}</Col>
                        <Col allPr={0}><span {...bemClasses('text')} children={i18n('listQuestion4')} /></Col>
                      </Row>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
          <Container {...bemClasses('block')} body>
            <Row {...bemClasses('row', 'therefore')} alignIcenter>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2>{i18n('h2_2a')}{bildUa}{i18n('h2_2b')}</h2>
                </div>
                <div {...bemClasses('description')}>
                  <p
                    {...bemClasses('text')}
                    children={i18n('description2_1', {
                      placeholderRU: numDesc(countCondition, 'параметр', 'разнообразных параметра', 'разнообразных параметров'),
                      placeholderUA: numDesc(countCondition, 'параметр', 'різноманітних параметра', 'різноманітних параметрів')
                    })}
                  />
                  <p {...bemClasses('text')} children={i18n('description2_2')} />
                  <p {...bemClasses('text')} children={i18n('description2_3')} />
                  <p {...bemClasses('text')} children={i18n('description2_4')} />
                </div>
                <div {...bemClasses('descriptionAfter')}>
                  <Link
                    {...bemClasses('link', 'shadow')}
                    builder={linksBildControl.sectionHowWeCalculateScore}
                    builderProps={{ title: i18n('moreAReliabilityIndex') }}
                    rel="nofollow"
                    // noRedirector
                    external
                  >
                    <span {...bemClasses('linkContent')}>
                      <span {...bemClasses('linkShadow')} />
                      <span {...bemClasses('text', 'link')} children={i18n('moreAReliabilityIndex')} />
                    </span>
                  </Link>
                </div>
              </Col>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <span {...bemClasses('img', 'laptopShield')} />
                </div>
              </Col>
            </Row>
          </Container>
        </LazyHydrate>
        <LazyHydrate whenIdle>
          <Container {...bemClasses('block', 'gray')}>
            <Row {...bemClasses('row', 'reliability')}>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0} mt={0} mp={0} />
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}><h2 children={i18n('h2_3')} /></div>
                <div {...bemClasses('description')}>
                  <Row {...bemClasses('item')} mpColumn>
                    <Col {...bemClasses('colImg')} mtAuto mpAuto allPr={0}>
                      <div {...bemClasses('imgContainer')}>
                        <div {...bemClasses('img', 'photo')}>
                          <div {...bemClasses('imgPic', null, 'thumb')}>
                            <span {...bemClasses(null, 'levelHigh', 'thumb__imgThumb')} />
                          </div>
                          <div {...bemClasses('onPhoto', 'points')}>
                            {reliabilityIndex.call(
                              this,
                              bemClasses,
                              {
                                investorConfidence: { all: maxRating, filled: exampleHighLevel },
                                level: 'highLevel'
                              }
                            )}
                          </div>
                        </div>
                        <span {...bemClasses('img', 'arrow top')} />
                      </div>
                    </Col>
                    <Col {...bemClasses('colText')} allPr={0}>
                      <p
                        {...bemClasses('text')}
                        children={i18n('description3_1', {
                          placeholderRU: numDesc(exampleHighLevel, 'балл', 'балла', 'баллов'),
                          placeholderUA: numDesc(exampleHighLevel, 'бал', 'бали', 'балів')
                        })}
                      />
                    </Col>
                  </Row>
                  <Row {...bemClasses('item')} mpColumn>
                    <Col {...bemClasses('colImg')} mtAuto mpAuto allPr={0}>
                      <div {...bemClasses('imgContainer')}>
                        <div {...bemClasses('img', 'photo')}>
                          <div {...bemClasses('imgPic', null, 'thumb')}>
                            <span {...bemClasses(null, 'levelLow', 'thumb__imgThumb')} />
                          </div>
                          <div {...bemClasses('onPhoto', 'points')}>
                            {reliabilityIndex.call(
                              this,
                              bemClasses,
                              {
                                investorConfidence: { all: maxRating, filled: exampleLowLevel },
                                level: 'lowLevel'
                              }
                            )}
                          </div>
                        </div>
                        <span {...bemClasses('img', 'arrow middle')} />
                      </div>
                    </Col>
                    <Col {...bemClasses('colText')} allPr={0}>
                      <p {...bemClasses('text')} children={i18n('description3_2', { placeholder: exampleLowLevel })} />
                    </Col>
                  </Row>
                  <Row {...bemClasses('item')} mpColumn>
                    <Col {...bemClasses('colImg')} mtAuto mpAuto allPr={0}>
                      <div {...bemClasses('imgContainer')}>
                        <div {...bemClasses('img', 'photo')}>
                          <div {...bemClasses('imgPic', null, 'thumb')}>
                            <span {...bemClasses(null, 'levelNA', 'thumb__imgThumb')} />
                          </div>
                          <div {...bemClasses('onPhoto', 'points')}>
                            {reliabilityIndex.call(this, bemClasses, { level: 'NA' })}
                          </div>
                        </div>
                        <span {...bemClasses('img', 'arrow bottom')} />
                      </div>
                    </Col>
                    <Col {...bemClasses('colText')} allPr={0}>
                      <p {...bemClasses('text')} children={i18n('description3_3')} />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </LazyHydrate>
        <LazyHydrate whenIdle>
          <Container {...bemClasses('block', 'white')}>
            <Row {...bemClasses('row', 'rules')} alignIcenter>
              <Col {...bemClasses('col', 'video')} allAuto allPr={0}>
                <div {...bemClasses('videoContainer')}>
                  <YoutubeIframe
                    className={bemClasses}
                    videoId={iframeSrcId}
                    otherProps={{
                      toContentWithoutBtn: true
                    }}
                  />
                </div>
              </Col>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}><h2 children={i18n('h2_4')} /></div>
                <div {...bemClasses('description')}>
                  <ul {...bemClasses('list')}>
                    <li {...bemClasses('listItem')}>
                      <Row alignIcenter>
                        <Col allAuto allPr={0}>
                          <span {...bemClasses('iconContainer')}>
                            <Icon {...bemClasses('icon')} type={iconTypes.catHigh} />
                          </span>
                        </Col>
                        <Col allPr={0}>
                          <p {...bemClasses('text')} children={i18n('listRule1')} />
                        </Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row alignIcenter>
                        <Col allAuto allPr={0}>
                          <span {...bemClasses('iconContainer')}>
                            <Icon {...bemClasses('icon')} type={iconTypes.catMedium} />
                          </span>
                        </Col>
                        <Col allPr={0}>
                          <p {...bemClasses('text')} children={i18n('listRule2')} />
                        </Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row alignIcenter>
                        <Col allAuto allPr={0}>
                          <span {...bemClasses('iconContainer')}>
                            <Icon {...bemClasses('icon')} type={iconTypes.catLow} />
                          </span>
                        </Col>
                        <Col allPr={0}>
                          <p {...bemClasses('text')} children={i18n('listRule3')} />
                        </Col>
                      </Row>
                    </li>
                    <li {...bemClasses('listItem')}>
                      <Row alignIcenter>
                        <Col allAuto allPr={0}>
                          <span {...bemClasses('iconContainer')}>
                            <Icon {...bemClasses('icon')} type={iconTypes.catNA} />
                          </span>
                        </Col>
                        <Col allPr={0}>
                          <p {...bemClasses('text')} children={i18n('listRule4')} />
                        </Col>
                      </Row>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
          <Container {...bemClasses('block')} body>
            <Row {...bemClasses('row', 'order')} alignIcenter>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}><h2 children={i18n('h2_5')} /></div>
                <div {...bemClasses('description')}>
                  <p {...bemClasses('text')} children={i18n('description5_1')} />
                  <div {...bemClasses('text', 'h3')}><h3 children={i18n('h3_5')} /></div>
                  <p {...bemClasses('text')} children={i18n('description5_2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <span {...bemClasses('img', 'laptopCharacterized')} />
                </div>
              </Col>
            </Row>
          </Container>
          <Container {...bemClasses('block', 'yellow')}>
            <Row {...bemClasses('row', 'sumUp')}>
              <Col {...bemClasses('col', 'img')} allAuto allFlex allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <span {...bemClasses('img', 'substrate cityBlobShape1')} />
                  <span {...bemClasses('img', 'substrate cityBlobShape2')} />
                  <span {...bemClasses('img', 'city')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'main')} allPr={0}>
                <div {...bemClasses('text', 'h2')}><h2 children={i18n('h2_6')} /></div>
                <div {...bemClasses('description')}>
                  <p {...bemClasses('text')} children={i18n('description6_1')} />
                  <ul {...bemClasses('list', 'links')}>
                    <DataProvider
                      preloaded={bigCities}
                      preloadedStatic
                      renderer={this.renderBigCity}
                    />
                  </ul>
                  <div {...bemClasses('text', 'h3')}><h3 children={i18n('h3_6')} /></div>
                  <div {...bemClasses('linkContainer')}>
                    <GeoLandings base={mainMenuBase} injectPropName="landingLinks" project="bild">
                      <LinkToNB />
                    </GeoLandings>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <Container body>
            <Breadcrumbs {...bemClasses('breadcrumbs')} data={dataBreadcrumbs} />
            <SeoText data={seoText} />
          </Container>
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: header,
              url: absoluteUrl(seoLocation),
              description,
              text: description,
              breadcrumb: {
                '@type': 'BreadcrumbList',
                itemListElement: map(dataBreadcrumbs, (item, key) => (
                  {
                    '@type': 'ListItem',
                    name: item.name,
                    position: key + 1,
                    item: absoluteUrl(item.url)
                  }
                ))
              }
            }}
          />
        </LazyHydrate>
      </div>
    );
  }
}

@I18nHoc(translates())
class LinkToNB extends PureComponent {
  static propTypes = {
    landingLinks: PropTypes.shape({}),
  };

  render() {
    const { landingLinks } = this.props;

    return (
      <Link
        {...bemClasses('link', 'shadow')}
        builder={linksBild.sectionLanding}
        builderProps={{
          url: landingLinks.flatsNewbuild ? landingLinks.flatsNewbuild.url : '/'
        }}
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('linkShadow')} />
          <span {...bemClasses('text', 'link')} children={this.i18n('linkToNext')} />
        </span>
      </Link>
    );
  }
}
